       <!-- Services -->

       <div class="row g-3 mb-3 pb-4 border-bottom">
        <div class="col-md-12">
          <h5 class="card-judul mb-0">Services</h5>
        </div>
      </div>

      <div class="row mb-3 pb-4">
        <div class="col-md-12">         


          <div class="accordion" id="ServicesAccordion">
            <div *ngIf="boatServices && boatServices.length; else noServices">
              <div *ngFor="let item of boatServices; let i = index" class="accordion-item">
                <h2 class="accordion-header d-flex justify-content-between" id="heading{{ i }}">
                    <button 
                      class="accordion-button" 
                      type="button" 
                      (click)="toggleAccordion(i)"
                      [class.collapsed]="!isAccordionServicesOpen[i]"
                      [attr.aria-expanded]="isAccordionServicesOpen[i]">
                      {{ item.judul }}
                    </button>
                  </h2>
                <div 
                  [id]="'collapse' + i" 
                  class="accordion-collapse collapse" 
                  [class.show]="isAccordionServicesOpen[i]"
                  [attr.aria-labelledby]="'heading' + i">
                  <div class="accordion-body">
                    <p style="display: none;"><strong>ID:</strong> {{ item.id }}</p>
                    <div [innerHTML]="item.ket"></div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noServices>
              <p>No Services available</p>
            </ng-template>
          </div>
          
          
          
        </div>
      </div>



     

